import { createContext } from "react";
import { userStore } from "../../../stores/sharedStores";
import { SwayyDashboardStore } from "./SwayyDashboardStore";
import { SwayyOrderStore } from "./SwayyOrderStore";
import { SwayyOrderDetailStore } from "./SwayyOrderDetailStore";

const swayyOrderStore = new SwayyOrderStore();
const swayyOrderDetailStore = new SwayyOrderDetailStore(swayyOrderStore);

export const swayyStoreContext = createContext({
  userStore,
  swayyDashboardStore: new SwayyDashboardStore(),
  swayyOrderStore,
  swayyOrderDetailStore,
});
